export const showComponentActions = [
  {
    name: 'system_show_component',
    label: 'Show Component',
    args: [
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'showComponentPage',
        label: 'Page',
        type: 'dropdown',
        optionsType: 'showComponentPageApi',
        options: [],
        value: '',
      },
      {
        name: 'showComponents',
        label: 'Show Component',
        type: 'dropdown',
        optionsType: 'showPageComponents',
        options: [],
        value: '',
      },
    ],
  },
];
